<template>
  <section
    class="w-full backgroundImage py-6 flex flex-col justify-center h-screen"
  >
    <div class="flex justify-center items-center h-full w-full">
      <form class="w-10/12" @submit.prevent="handleSubmit">
        <p class="text-2xl text-gray-dark italic font-semibold">
          Select Preferences
        </p>
        <p class="text-sm py-2 mb-8 text-gray-dark italic">
          Select your preferred categories.
        </p>
        <div v-if="categories" class="flex flex-wrap cursor-pointer">
          <div
            class="flex relative items-center w-48 uppercase mr-4 mb-4 rounded-lg h-16 text-gray-dark shadow-lg ring-1 ring-gray-200 hover:border-green-dark text-sm"
            :class="{ 'ring-green-dark': c.selected }"
            v-for="c in categories"
            :key="c.id"
            @click="addCategory(c.id, c.name)"
            v-on:mouseenter="innerBoxGreenColorAddId(c.id)"
            v-on:mouseleave="innerBoxGreenColorRemoveId()"
          >
            <div class="flex ml-4 items-center">
              <div
                class="w-8 h-8 bg-gray-400 mr-2 mt-0.5 rounded-lg"
                :class="{ 'bg-green-dark': c.id == isBoxGreenId || c.selected }"
              ></div>
              <p class="-mt-0.5">{{ c.name }}</p>
            </div>
            <div class="absolute top-0 right-0" v-if="c.selected">
              <span>
                <img
                  :src="require(`@/assets/img/checked.png`)"
                  alt=""
                  class="w-6 h-6 rounded-full"
                />
              </span>
            </div>
          </div>
        </div>
        <div v-if="selectedCategories"></div>
        <div v-if="$v.selectedCategories.$error">
          <small class="text-red-500" v-if="!$v.selectedCategories.maxLength">
            Maximum of 4 categories allowed
          </small>
          <small class="text-red-500" v-if="!$v.selectedCategories.required">
            Category is required
          </small>
        </div>
        <div class="flex justify-end mt-6">
          <button
            type="submit"
            class="w-56 h-8 text-sm bg-green-light text-white rounded-md"
          >
            Continue
          </button>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      category: "",
      user: JSON.parse(localStorage.getItem("user")),
      categories: [],
      selectedCategories: [],
      isBoxGreenId: "",
    };
  },
  validations: {
    selectedCategories: {
      required,
      maxLength: maxLength(4),
    },
  },
  computed: {
    ...mapGetters(["categoriesList"]),
  },
  methods: {
    ...mapActions([
      "getCategoriesList",
      "getLanguagesList",
      "userCompleteSignup",
      "getUserUpcomingSessions",
      "guestCompleteSignup",
    ]),

    async handleSubmit() {
      this.selectedCategories = [];
      //putting the selected category from categories array to  selectedCategory Array for validation.
      this.categories.forEach((d) => {
        if (d.selected) {
          this.selectedCategories.push(d);
        }
      });
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("invalid");
        return;
      }
      var category_id = [];
      this.categories.forEach((d) => {
        if (d.selected) {
          category_id.push(d.id);
        }
      });

      //If current user is a verified guest user
      let isGuest = localStorage.getItem("isGuest");
      let jsonData = sessionStorage.getItem("registerGuestData");
      if (isGuest == 1 && jsonData) {
        let guestData = JSON.parse(jsonData);

        if (!guestData) {
          console.log(
            "Error: something went wrong when fetching your guest data."
          );
          return;
        }

        guestData["category_id"] = category_id;
        this.guestCompleteSignup(guestData).then(() => {
          localStorage.setItem("isCompleteSignup", true);
          localStorage.removeItem("isGuest");
          sessionStorage.removeItem("registerGuestData");
          this.$router.push({ name: "home" });
        });

        return;
      }

      //Normal account signup
      const data = {
        category_id: category_id,
      };

      await this.userCompleteSignup(data).then(() => {
        localStorage.setItem("isCompleteSignup", true);
        if (localStorage.getItem("PreviousRoute")) {
          this.$router.push(localStorage.getItem("PreviousRoute"));
        } else {
          this.$router.push({ name: "home" });
        }
      });
    },

    addCategory(id, name) {
      this.categories.forEach((ele) => {
        if (ele.id == id) {
          ele.selected = !ele.selected;
        }
      });
    },

    removeCategory(id, name) {
      this.categories.push({ id: id, name: name });
      const index = this.selectedCategories.findIndex((e) => e.id === id);
      if (index !== -1) {
        this.selectedCategories.splice(index, 1);
      }
    },

    innerBoxGreenColorAddId(id) {
      this.isBoxGreenId = id;
    },

    innerBoxGreenColorRemoveId() {
      this.isBoxGreenId = "";
    },
  },
  async created() {
    //TODO: ADD POSSIBLE EXTRA CHECK
    // this.signupVerification({ id: this.user.id }).then(() => {
    //   if (this.user && this.user.user_type === 2) {
    //     this.$router.push({ name: "TrainerDetailedRegisteration" });
    //   } else {
    //     this.$router.push({ name: "home" });
    //   }
    // });

    // if (JSON.parse(localStorage.getItem("isCompleteSignup"))) {
    if (this.user && this.user.initial_update == 1) {
      this.$router.push({ name: "home" });
    }
    await this.getCategoriesList();
    const categories = [];
    this.categoriesList.map((cat) => {
      categories.push({ name: cat.name, id: cat.id, selected: false });
    });
    this.categories = categories;
  },
};
</script>